import { Injectable, inject } from "@angular/core";
import { Actions, ofType, createEffect } from "@ngrx/effects";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { catchError, mergeMap, of } from "rxjs";
import { SnackbarTypes } from "app/models/snackbar.types";
import { AccountService } from "app/services/account/account.service";
import { CommonService } from "app/services/common/common.service";
import { logoutAction } from "../actions/auth.actions";
import {
  getSubscriptionsByClientAccount,
  subscriptionsLoaded,
  subscriptionsError,
} from "../actions/subscriptions.actions";
import { Constants } from "app/core/constants/constants";
import { SubscriptionModel } from "app/shared/models/subscription.model";
import { ProductType } from "app/models/account.model";

@Injectable()
export class SubscriptionsEffect {
  private actions$ = inject(Actions);
  private router = inject(Router);
  private store = inject(Store);
  private commonService = inject(CommonService);
  private accountService = inject(AccountService);



  constructor() { }

  getSubscriptionsByClientAccount$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(getSubscriptionsByClientAccount),
      mergeMap(({ clientAccountId }) => {
        if (clientAccountId) {
          return this.accountService
            .getSubscriptionsByClientAccount({ clientAccountId })
            .pipe(
              mergeMap((subscriptions: SubscriptionModel[]) => {
                const subscription = subscriptions.find(subscription => subscription.applicationType === ProductType.rhPartner);
                if (!subscription || subscription?.suspended || subscription?.expired) {
                  this.handleSuspendedOrExpiredSubscription();
                }
                return of(subscriptionsLoaded({ subscription }));
              }),
              catchError((error) => {
                console.error("Error fetching subscriptions:", error);
                return of(subscriptionsError({ error }));
              }),
            );
        }
        return of(
          subscriptionsError({ error: "Client account id is required" }),
        );
      }),
    );
  });

  private handleSuspendedOrExpiredSubscription(): void {
    this.commonService.showSnackBar({
      message: "errors.subscriptionSuspended",
      snackBarType: SnackbarTypes.errorMessage,
    });
    this.store.dispatch(logoutAction());
    this.router.navigate([Constants.logoutRoute]);
  }
}
